export const APP_ROUTES = {
  HOME: {
    path: "/*",
    to: "/",
  },
  DASHBOARD: {
    path: "/*",
    UPLOAD: {
      path: "upload/*",
      to: "upload",
      NEW: {
        path: "new/*",
        to: "upload/new",
      },
    },
    TEMPLATES: {
      path: "templates/*",
      to: "templates",
    },
    TEMPLATES_DETAIL: {
      path: "templates/:id/*",
      to: "templates/:id",
    },
    CAMPAIGN: {
      path: "campaigns/*",
      to: "campaigns",
    },
    CAMPAIGN_DETAIL: {
      path: "campaigns/:id/*",
      to: "campaigns/:id",
    },
  },
  LOGIN: {
    path: "login/*",
    to: "/login",
  },
  VERIFY: {
    path: "verify/*",
    to: "/verify",
  },
  ACCESS_DENIED: {
    path: "access-denied/*",
    to: "/access-denied",
  },
  NOT_FOUND: {
    path: "404/*",
    to: "/404",
  },
};
